import { typeof as _typeof, slicedToArray as _slicedToArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils, TabsContextProvider, Tabs, Tab, TabPanel as TabPanel$1, List } from '@costar/theme-ui';
import React, { useState, useCallback, useMemo } from 'react';
import renderOptions from './render-options.esm.js';
import { SelectKeyNavContextProvider } from './select-key-nav-context.esm.js';

var _excluded = ["ref", "ariaLabel", "ariaLabelledBy"];
function getGroupKey(selection, fallback) {
  if (Array.isArray(selection) && "".concat(selection[0]).includes('.')) {
    return "".concat(selection[0]).slice(0, "".concat(selection[0]).indexOf('.'));
  }
  return fallback !== null && fallback !== void 0 ? fallback : '';
}
var tabScrollButtonProps = {
  enableTransition: true
};
var TabPanel = function TabPanel(props) {
  var panelKey = props.panelKey,
    extendedContent = props.extendedContent,
    extendedContentTop = props.extendedContentTop,
    handleClose = props.handleClose,
    isMultiSelect = props.isMultiSelect,
    listProps = props.listProps,
    options = props.options,
    renderItem = props.renderItem,
    selection = props.selection,
    selectionClick = props.selectionClick,
    showSelectionCheckbox = props.showSelectionCheckbox;
  var optionsAsObject = options;
  var content = useMemo(function () {
    var _options, _panelKey;
    return renderOptions((_options = (_panelKey = optionsAsObject[panelKey]) === null || _panelKey === void 0 ? void 0 : _panelKey.options) !== null && _options !== void 0 ? _options : utils.EMPTY_OBJECT, renderItem, selection, selectionClick, handleClose, extendedContent, extendedContentTop, panelKey);
  }, [extendedContent, extendedContentTop, handleClose, optionsAsObject, panelKey, renderItem, selection, selectionClick]);
  return /*#__PURE__*/React.createElement(TabPanel$1, {
    value: panelKey
  }, /*#__PURE__*/React.createElement(SelectKeyNavContextProvider, {
    options: options,
    selectionClick: selectionClick,
    handleClose: handleClose,
    isMultiSelect: isMultiSelect
  }, /*#__PURE__*/React.createElement(List, _extends({
    variant: showSelectionCheckbox ? 'select-list-show-checkbox' : 'select-list'
  }, listProps), content)));
};
var TabContent = function TabContent(props) {
  var renderItem = props.renderItem,
    showSelectionCheckbox = props.showSelectionCheckbox,
    _props$listProps = props.listProps,
    listProps = _props$listProps === void 0 ? utils.EMPTY_OBJECT : _props$listProps,
    isMultiSelect = props.isMultiSelect,
    extendedContent = props.extendedContent,
    extendedContentTop = props.extendedContentTop,
    options = props.options,
    selection = props.selection,
    handleClose = props.handleClose,
    selectionClick = props.selectionClick;
  if (_typeof(options) !== 'object' || utils.isEmptyObject(options) || selection !== undefined && isMultiSelect && !Array.isArray(selection)) {
    throw new Error('invalid state');
  }
  var curSelection = Array.isArray(selection) ? selection : selection ? [selection] : [];
  var optionsAsObject = options;
  var optionGroupKeys = Object.keys(optionsAsObject);
  var curGroupKey = getGroupKey(curSelection, optionGroupKeys[0]);
  var _useState = useState(curGroupKey),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var handleTabChanged = useCallback(function (value) {
    return setSelectedTab("".concat(value));
  }, []);
  var ref = listProps.ref,
    ariaLabel = listProps.ariaLabel,
    ariaLabelledBy = listProps.ariaLabelledBy,
    restList = _objectWithoutProperties(listProps, _excluded);
  return /*#__PURE__*/React.createElement(TabsContextProvider, {
    variant: "select-tab",
    selection: selectedTab,
    onChange: handleTabChanged
  }, /*#__PURE__*/React.createElement(Tabs, {
    ref: ref,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    indicatorLength: 0.8,
    TabScrollButtonProps: tabScrollButtonProps
  }, optionGroupKeys.map(function (k, indx) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: "select-option-tab-".concat(indx),
      value: k
    }, optionsAsObject[k].label);
  })), optionGroupKeys.map(function (k, indx) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: "select-option-tab-panel-".concat(indx),
      panelKey: k,
      listProps: restList,
      extendedContent: extendedContent,
      extendedContentTop: extendedContentTop,
      handleClose: handleClose,
      isMultiSelect: isMultiSelect,
      options: options,
      renderItem: renderItem,
      selection: selection,
      selectionClick: selectionClick,
      showSelectionCheckbox: showSelectionCheckbox
    });
  }));
};
function renderTabOptionsContent (renderItem, showSelectionCheckbox) {
  var listProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils.EMPTY_OBJECT;
  var isMultiSelect = arguments.length > 3 ? arguments[3] : undefined;
  var extendedContent = arguments.length > 4 ? arguments[4] : undefined;
  var extendedContentTop = arguments.length > 5 ? arguments[5] : undefined;
  // standard overridable contract to render content of popover
  return function TabOptionContent(options, selection, handleClose, selectionClick) {
    return /*#__PURE__*/React.createElement(TabContent, {
      renderItem: renderItem,
      showSelectionCheckbox: showSelectionCheckbox,
      listProps: listProps,
      isMultiSelect: isMultiSelect,
      extendedContent: extendedContent,
      extendedContentTop: extendedContentTop,
      options: options,
      selection: selection,
      handleClose: handleClose,
      selectionClick: selectionClick
    });
  };
}

export default renderTabOptionsContent;
//# sourceMappingURL=render-tab-options-content.esm.js.map
